export default __webpack_public_path__ + "static/media/youtube-logo-white.edcdd4ad.png";